
























import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';

import { getAgoString } from '@/utils/general';

@Component
export default class GoToCard extends Vue {
	@State private launcherState !: any;
	@State private storeInputText !: any;

	@Action private deleteActionitem!: any;
	@Action private goTo!: any;

	@Prop() private item !: any;

	private get name() {
		if (this.launcherState === 'INPUT') {
			return this.storeInputText;
		} else {
			return this.item.name;		
		}
	}

	private get url() {
		if (this.item.args) {
			return this.item.args.url;
		} else {
			return document.location.href;
		}
	}

	private get title() {
		if (this.item.options) {
			return this.item.options.props.title;
		} else {
			return null;
		} 
	}

	private get createdAt() {
		if (this.item.options) {
			return getAgoString(this.item.options.created_at);
		} else {
			return null;
		} 
	}

	private get timesUsed() {
		if (this.item.options) {
			return this.item.options.timesUsed;
		} else {
			return null;
		}
	}

	private async deleteActionitem_() {
		await this.deleteActionitem(this.item.id);
	}
}

